import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/lib/api'
import { queryKeys } from '@/lib/query/keys'
import { useSession } from '@/features/auth/hooks/useSession'
import { resolveWorkspaceId } from '@/lib/workspace-routing'
import {
  mapConversationSummary,
} from '../lib/conversationAdapter'

type CreateConversationRequest = {
  name: string
  icon?: string
  meta?: Record<string, unknown>
}

export function useCreateConversation() {
  const { token, selectedContainer } = useSession()
  const queryClient = useQueryClient()
  const workspaceId = resolveWorkspaceId(selectedContainer)

  return useMutation({
    mutationFn: async (data: CreateConversationRequest) => {
      const conversation = await api.workspaces.createConversation(token, workspaceId, {
        title: data.name,
      })
      return mapConversationSummary(conversation)
    },
    onSuccess: (newConversation) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.conversations.lists() })
      queryClient.setQueryData(queryKeys.conversations.detail(newConversation.id), {
        conversation: newConversation,
      })
    },
  })
}
